module.exports = __webpack_public_path__ + "img/errorBox.6a4d3248.svg";